var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("filter-expression", {
        attrs: {
          columns: _vm.filterColumns,
          "dataset-name": _vm.datasetName,
          "filter-groups": _vm.filterGroups,
          operator: _vm.operator,
          mode: "simple",
        },
        on: {
          "filters-updated": _vm.handleFiltersUpdated,
          "operator-changed": _vm.handleOperatorChange,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-list-wrapper" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              {
                staticClass: "info-badge table-info-badge",
                class: { invisible: _vm.totalCount === -1 },
              },
              [
                _c("span", { staticClass: "badge-text table-badge-text" }, [
                  _vm._v(_vm._s(_vm.tableBadgeText)),
                ]),
                _vm._v(" "),
                _vm.selectionLimitReached && _vm.dynamicFilter
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          staticClass: "badge-link",
                          on: { click: _vm.handleDynamicFilterClicked },
                        },
                        [_vm._v("Add unlimited devices with Dynamic Filter")]
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("vyTable", {
              attrs: {
                columns: _vm.columns,
                dataIndex: _vm.dataIndex,
                pageSize: _vm.pageSize,
                autoFetchConfig: _vm.autoFetchConfig,
                setFirstPage: _vm.setFirstPage,
                disableRowSelection: _vm.selectionLimitReached,
                showRowSelectionColumn: true,
                selectedRows: _vm.selectedRowsForUpdate,
                selectable: -1,
                "nested-field-separator": _vm.nestedFieldSeparator,
              },
              on: {
                "row-selection-changed": _vm.handleRowSelectionChange,
                "full-page-selected": _vm.handleFullPageSelected,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "list-container" }, [
          _c("div", { staticClass: "info-badge list-info-badge" }, [
            _c("span", { staticClass: "badge-text list-badge-text" }, [
              _vm._v(_vm._s(_vm.listBadgeText)),
            ]),
            _vm._v(" "),
            _vm.selectedData.length > 0
              ? _c(
                  "span",
                  {
                    staticClass: "list-badge-delete-icon",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleRemoveAllSelections.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [_c("i", { staticClass: "far fa-trash-alt" })]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "selections-container" },
            _vm._l(_vm.selectedData, function (selection) {
              return _c(
                "div",
                {
                  key: selection[_vm.dataIndex],
                  staticClass: "selection-container",
                },
                [
                  _c("div", { staticClass: "selection" }, [
                    _c("span", { staticClass: "selection-text" }, [
                      _vm._v(_vm._s(selection[_vm.displayField])),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "selection-delete-icon",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleRemoveSelection(selection)
                          },
                        },
                      },
                      [_c("i", { staticClass: "far fa-trash-alt" })]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }